import { SEARCH_DOCS } from 'utility/api-paths';
import { fetchService } from './fetchService';

interface ConfluenceContentResponse {
  title: string;
  content: string;
}

interface SearchDocsResponseItem {
  title: string;
  page_id: string;
}

export const fetchConfluenceContent = async (pageId: string): Promise<ConfluenceContentResponse> => {
  const fullUrl = `fetch-confluence/fetch-confluence-content/${pageId}`;

  try {
    return await fetchService<ConfluenceContentResponse>(fullUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : 'An unknown error occurred.');
  }
};


export const searchDocs = async (searchInput: string): Promise<SearchDocsResponseItem[]> => {
  const fullUrl = `${SEARCH_DOCS}`;

  try {
    return await fetchService<SearchDocsResponseItem[]>(fullUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: { search_query: searchInput }
    });
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : 'An unknown error occurred.');
  }
};
